<template>
  <v-container fluid class="legal-page">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <PageBack class="mb-4" />
        <v-card elevation="2" class="pa-6">
          <div v-if="loading" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div v-else-if="error" class="text-center pa-8">
            <v-icon large color="error">mdi-alert-circle-outline</v-icon>
            <p class="mt-2">Impossible de charger le document.</p>
          </div>
          <div v-else class="legal-content" v-html="renderedContent" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({ html: false, linkify: true })

const TODO_PATTERN = /\[[^\]]*À COMPLÉTER[^\]]*\]/g

function highlightTodos(html) {
  return html.replace(TODO_PATTERN, (match) => `<mark class="legal-todo">${match}</mark>`)
}

export default {
  components: { PageBack },
  name: 'LegalView',
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    renderedContent: '',
    loading: true,
    error: false,
  }),
  async created() {
    this.loading = true
    this.error = false
    try {
      const res = await fetch(this.src)
      if (!res.ok) throw new Error('fetch failed')
      const text = await res.text()
      this.renderedContent = highlightTodos(md.render(text))
    } catch {
      this.error = true
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.legal-content {
  font-size: 15px;
  line-height: 1.7;
}

.legal-content :deep(h1) {
  font-size: 1.8rem;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
}

.legal-content :deep(h2) {
  font-size: 1.4rem;
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 0.25rem;
}

.legal-content :deep(h3) {
  font-size: 1.15rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.4rem;
}

.legal-content :deep(table) {
  border-collapse: collapse;
  width: 100%;
  margin: 1rem 0;
}

.legal-content :deep(th),
.legal-content :deep(td) {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
}

.legal-content :deep(th) {
  background-color: rgba(128, 128, 128, 0.1);
  font-weight: 600;
}

.legal-content :deep(hr) {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 1.5rem 0;
}

.legal-content :deep(mark.legal-todo) {
  background: rgba(255, 152, 0, 0.25);
  color: inherit;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 600;
}
</style>
